import BaseModel from '../base';
import QuestionTag from './tag/index';
import AnswerOption from '../answer/option/index';

import constants from './constants';
import glossary from './glossary';

export default class Question extends BaseModel {
  constructor(question = {}, url) {
    super(question, url);

    this.name = question.name;
    this.description = question.description;
    this.type = question.type;
    this.sort_order = question.sort_order;
    this.settings = question.settings;
    this.criterias = question.criterias || [];
    this.event_poll_id = question.event_poll_id;

    this.options = (question.options || []).map((i) => new AnswerOption(i, 'option'));
    this.tag = question.tag ? new QuestionTag(question.tag) : undefined;
  }

  get displayType() {
    const { type } = this;
    const { QUESTION_TYPES_DATA } = glossary;

    return QUESTION_TYPES_DATA[type];
  }

  get maxPoints() {
    const { calcMaxPoints } = this.displayType;
    return calcMaxPoints(this);
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
